import { useCallback } from "react";

type ChartbeatVirtualPageData = {
  /** Absolute url of the page to pass to chartbeat */
  url: string;
  /** Title of the page to pass to chartbeat */
  title: string;
  /** Authors of the article to pass to chartbeat, if avaliable  */
  authors?: string;
  /** Sections of the article to pass to chartbeat, if avaliable */
  sections?: string;
};

/**
 * This hook is used to send virtual page data to Chartbeat.
 * It provides a function to send the data using the global `pSUPERFLY` object.
 * https://docs.chartbeat.com/cbp/tracking/standard-websites/single-page-apps#single-page-apps-and-virtual-page-change-implementation
 */
const useSendChartbeatViritualPageData = () => {
  const sendChartbeatData = useCallback(
    (dataObject: ChartbeatVirtualPageData) => {
      if (typeof window === "undefined") return;
      if (!window.pSUPERFLY) return;
      if (typeof window.pSUPERFLY !== "function") return;

      window.pSUPERFLY.virtualPage({
        useCanonical: true,
        useCanonicalDomain: true,
        title: dataObject.title,
        sections: dataObject.sections || "",
        authors: dataObject.authors || "",
        path: dataObject.url,
      });
    },
    []
  );

  return { sendChartbeatData };
};

export default useSendChartbeatViritualPageData;
